import React from 'react';
import {FormattedMessage} from 'react-intl';

import {Icon} from '@stubhub/bamboo';
import {DISCLOSURE_CATEGORY_ICONS, DISCLOSURE_ICON_NAMES, DISCLOSURE_IDS} from '@stubhub/disclosure-utils';

import BulletIcon from '../../components/icons/bullet/index';
import OnLocationLogo from '../../components/icons/on_location_logo';
import {disclosureMessages} from '../disclosureCategories/disclosureCategories';
// TODO: Consolidate All Icons into one file

const Icons = {
  2: <Icon name={DISCLOSURE_ICON_NAMES.ACCESIBILITY} />,
  4: <Icon name={DISCLOSURE_ICON_NAMES.PARKING} />,
  6: <Icon name={DISCLOSURE_ICON_NAMES.AISLE_SEAT} />,
  1: <Icon name={DISCLOSURE_ICON_NAMES.OBSTRUCTED_VIEW} />,
};

export const getFilterIcon = (id) => {
  let Icon = Icons[id];
  if (!Icon) {
    Icon = <BulletIcon />;
  }

  return Icon;
};

// These are the same for Android: https://github.ebay.com/StubHub-Mobile/android/blob/d4cc2d7be28c1eab823f70837c1358e6c4886dcb/Domains/Core/src/main/java/com/stubhub/core/models/buy/event/StaticSeatFeatureAttributes.java
const Aisle = new Set([DISCLOSURE_IDS.AISLE_SEAT]);
const Parking = new Set([DISCLOSURE_IDS.PARKING]);
const ObstrucedView = new Set([
  DISCLOSURE_IDS.OBSTRUCTED_LIMITED_VIEW,
  DISCLOSURE_IDS.PARTIAL_VIEW,
  DISCLOSURE_IDS.RESTRICTED_VIEW,
  DISCLOSURE_IDS.NO_VIEW,
  DISCLOSURE_IDS.POSSIBLE_OBSTRUCTION,
  DISCLOSURE_IDS.REAR_STAGE_VIEW,
  DISCLOSURE_IDS.LIMITED_SIDE_VIEW,
  DISCLOSURE_IDS.SIDE_VIEW,
  DISCLOSURE_IDS.RESTRICTED_VIEW2,
]);
const Wheelchair = new Set([
  DISCLOSURE_IDS.WHEELCHAIR_ONLY,
  DISCLOSURE_IDS.ADA_ACCESSIBLE,
  DISCLOSURE_IDS.ADA_WHEELCHAIR_ACCESIBLE_ONLY,
]);
export const VIP_Hospitality = new Set([
  DISCLOSURE_IDS.TOUCHDOWN_CLUB,
  DISCLOSURE_IDS.LIVE_54,
  DISCLOSURE_IDS.ON_THE_FIFTY,
  DISCLOSURE_IDS.LEGENDS,
]);

export const getTicketListIcons = (listingAttributeListWithCategories = {}) => {
  const displayedIconsMap = new Map();
  const genericIconsMap = new Map();

  const styles = {
    color: '#677383',
    width: '14px',
    height: '14px',
  };

  const listingAttributeList = Object.keys(listingAttributeListWithCategories).map((attribute) =>
    parseInt(attribute, 10)
  );

  // These two icons need to be first
  if (VIP_Hospitality.has(...listingAttributeList)) {
    displayedIconsMap.set('VIP', {
      id: 'vip',
      icon: <OnLocationLogo />,
      label: <FormattedMessage id="ticket.listIcons.vip" defaultMessage="VIP" />,
    });
    displayedIconsMap.set('Food', {
      id: 'food',
      icon: <Icon name={DISCLOSURE_ICON_NAMES.RESTAURANT} {...styles} />,
      label: <FormattedMessage id="ticket.listIcons.restaurant" defaultMessage="Food and beverage" />,
    });
  }

  for (let i = 0; i < listingAttributeList.length; i++) {
    const listingAttribute = listingAttributeList[i];

    if (Aisle.has(listingAttribute)) {
      displayedIconsMap.set('Aisle', {
        id: 'aisle',
        icon: <Icon name={DISCLOSURE_ICON_NAMES.AISLE_SEAT} {...styles} />,
        label: <FormattedMessage id="ticket.listIcons.aislee" defaultMessage="Aisle seat" />,
      });
    } else if (Parking.has(listingAttribute)) {
      displayedIconsMap.set('Parking', {
        id: 'parking',
        icon: <Icon name={DISCLOSURE_ICON_NAMES.PARKING} {...styles} />,
        label: <FormattedMessage id="ticket.listIcons.parking" defaultMessage="Parking pass" />,
      });
    } else if (ObstrucedView.has(listingAttribute)) {
      displayedIconsMap.set('ObstrucedView', {
        id: 'obstructed-view',
        icon: <Icon name={DISCLOSURE_ICON_NAMES.OBSTRUCTED_VIEW} {...styles} />,
        label: <FormattedMessage id="ticket.listIcons.obstructed" defaultMessage="Obstructed view" />,
      });
    } else if (Wheelchair.has(listingAttribute)) {
      displayedIconsMap.set('Wheelchair', {
        id: 'wheelchair',
        icon: <Icon name={DISCLOSURE_ICON_NAMES.ACCESIBILITY} {...styles} />,
        label: <FormattedMessage id="ticket.listIcons.accesibility" defaultMessage="Accessible seats" />,
      });
    } else if (!VIP_Hospitality.has(listingAttribute)) {
      // If this listingAttribute is in VIP Hospitality, don't add a general disclosure icon
      const disclosureCategory =
        listingAttributeListWithCategories[listingAttribute] || DISCLOSURE_CATEGORY_ICONS.RESTRICTIONS_LIMITATIONS;
      genericIconsMap.set(disclosureCategory, {
        id: disclosureCategory.toLowerCase(),
        icon: <Icon name={disclosureCategory} {...styles} />,
        label: <FormattedMessage {...disclosureMessages[disclosureCategory]} />,
      });
    }
  }

  return [...displayedIconsMap.values(), ...genericIconsMap.values()];
};
